import { render, staticRenderFns } from "./Parrafo.vue?vue&type=template&id=5faa0ea4&"
import script from "./Parrafo.vue?vue&type=script&lang=js&"
export * from "./Parrafo.vue?vue&type=script&lang=js&"
import style0 from "./Parrafo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports